import { jsxs, jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { space, colors } from "@ardoq/design-tokens";
import { Breadcrumbs2, ComponentRepresentation } from "@ardoq/basic-components";
import { WorkspaceIcon, IconSize, IconName } from "@ardoq/icons";
import { InlineText } from "@ardoq/typography";
import { FlexBox } from "@ardoq/layout";
var CustomOptionType = /* @__PURE__ */ ((CustomOptionType2) => {
  CustomOptionType2["ComponentWithContext"] = "component-with-context";
  CustomOptionType2["WorkspaceWithFolderPath"] = "workspace-with-folder-path";
  return CustomOptionType2;
})(CustomOptionType || {});
const ComponentWithContext = ({
  name,
  path,
  rootWorkspaceName,
  representationData: { icon, isImage, contrastColor, value },
  isNewComponent,
  folderPath
}) => {
  return /* @__PURE__ */ jsxs(OptionContainer, { children: [
    isNewComponent && /* @__PURE__ */ jsx(InlineText, { variant: "caption", color: "textSubtle", children: "New component" }),
    folderPath && folderPath.length > 0 && /* @__PURE__ */ jsx(InlineText, { variant: "caption", color: "textSubtle", children: /* @__PURE__ */ jsx(Breadcrumbs2, { breadcrumbs: folderPath }) }),
    /* @__PURE__ */ jsxs(FlexBox, { align: "center", gap: "xsmall", children: [
      rootWorkspaceName && /* @__PURE__ */ jsx(WorkspaceIcon, { iconSize: IconSize.SMALL, color: colors.grey50 }),
      /* @__PURE__ */ jsx(InlineText, { variant: "caption", color: "textSubtle", children: rootWorkspaceName ? rootWorkspaceName : "No workspace selected" })
    ] }),
    path && /* @__PURE__ */ jsx(InlineText, { variant: "caption", color: "textSubtle", children: /* @__PURE__ */ jsx(
      Breadcrumbs2,
      {
        breadcrumbs: path,
        leadingIcon: {
          name: IconName.NONE,
          size: IconSize.SMALL,
          rightMargin: "xsmall"
        }
      }
    ) }),
    /* @__PURE__ */ jsxs(FlexBox, { align: "center", gap: "small", children: [
      /* @__PURE__ */ jsx(
        ComponentRepresentation,
        {
          isImage: isImage ?? false,
          value: value ?? null,
          icon,
          iconSize: IconSize.MEDIUM,
          style: {
            fontSize: IconSize.MEDIUM,
            color: contrastColor
          }
        }
      ),
      /* @__PURE__ */ jsx(InlineText, { variant: "text1", children: name })
    ] })
  ] });
};
const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.small};
  flex: 1;
  overflow: hidden;
  overflow-x: hidden;
`;
const CustomOption = ({ customData }) => {
  if (!customData) {
    return null;
  }
  switch (customData.type) {
    case CustomOptionType.ComponentWithContext:
      return /* @__PURE__ */ jsx(ComponentWithContext, { ...customData });
    default: {
      const exhaustiveCheck = customData.type;
      throw new Error(`Unhandled case: ${exhaustiveCheck}`);
    }
  }
};
export {
  CustomOption,
  CustomOptionType
};
//# sourceMappingURL=index.js.map
